import { render } from "./TypeField.vue?vue&type=template&id=35f7263c&scoped=true"
import script from "./TypeField.vue?vue&type=script&lang=js"
export * from "./TypeField.vue?vue&type=script&lang=js"

import "./TypeField.vue?vue&type=style&index=0&id=35f7263c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35f7263c"]])

export default __exports__